import React, { useEffect, useRef, useState } from 'react';
import { animated, config, useSpring } from 'react-spring';
import '../styles/QuoteSection.css';

const QuoteSection = () => {
  const quoteRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const quoteElement = quoteRef.current;

    if (!quoteElement) {
      return undefined;
    }

    if (typeof IntersectionObserver === 'undefined') {
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting && entry.intersectionRatio > 0.18);
      },
      {
        threshold: [0, 0.18, 0.35],
        rootMargin: '0px 0px -8% 0px',
      },
    );

    observer.observe(quoteElement);

    return () => {
      observer.disconnect();
    };
  }, []);

  const quoteSpring = useSpring({
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0px)' : 'translateY(28px)',
    config: config.gentle,
  });

  return (
    <section ref={quoteRef} className="quote-section" aria-label="Portfolio statement">
      <div className="section-shell quote-section-shell">
        <animated.div style={quoteSpring} className="quote-section-content">
          <p className="quote-section-text">
            "Anything you imagine can be implemented in code."
          </p>
        </animated.div>
      </div>
    </section>
  );
};

export default QuoteSection;
